<script>
    export let size = 24
    export let color = '#C5281C'
    export let style = ''
    export let title = null
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <rect
        fill="none"
        stroke={color}
        stroke-linejoin="round"
        stroke-width="32"
        x="48"
        y="80"
        width="416"
        height="384"
        rx="48"
    ></rect>
    <circle cx="296" fill={color} cy="232" r="24"></circle><circle
        cx="376"
        fill={color}
        cy="232"
        r="24"
    ></circle>
    <circle cx="296" fill={color} cy="312" r="24"></circle><circle
        cx="376"
        fill={color}
        cy="312"
        r="24"
    ></circle>
    <circle cx="136" fill={color} cy="312" r="24"></circle><circle
        cx="216"
        fill={color}
        cy="312"
        r="24"
    ></circle>
    <circle cx="136" fill={color} cy="392" r="24"></circle><circle
        cx="216"
        fill={color}
        cy="392"
        r="24"
    ></circle>
    <circle cx="296" fill={color} cy="392" r="24"></circle>
    <line
        fill="none"
        stroke={color}
        stroke-linejoin="round"
        stroke-width="32"
        stroke-linecap="round"
        x1="128"
        y1="48"
        x2="128"
        y2="80"
    ></line>
    <line
        fill="none"
        stroke={color}
        stroke-linejoin="round"
        stroke-width="32"
        stroke-linecap="round"
        x1="384"
        y1="48"
        x2="384"
        y2="80"
    ></line>
    <line
        fill="none"
        stroke={color}
        stroke-linejoin="round"
        stroke-width="32"
        x1="464"
        y1="160"
        x2="48"
        y2="160"
    ></line>
</svg>
